import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('mb_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Brand constants
export const WHATSAPP_NUMBER = '919434466043';
export const BRAND_EMAIL = 'mahabirbastralaya99@gmail.com';
export const BRAND_ADDRESS = {
  line1: 'JP Mansion, Opp. Axis Bank',
  line2: 'NS Road, Jaigaon',
  line3: 'District – Alipurduar, West Bengal, 736182',
  full: 'Mahabir Bastralaya, JP Mansion, Opp. Axis Bank, NS Road, Jaigaon, District- Alipurduar, West Bengal, Pin- 736182',
};
export const GOOGLE_MAPS_EMBED_QUERY = encodeURIComponent(
  'Mahabir Bastralaya, JP Mansion, NS Road, Jaigaon, Alipurduar, West Bengal 736182'
);
export const GOOGLE_MAPS_LINK = `https://www.google.com/maps/search/?api=1&query=${GOOGLE_MAPS_EMBED_QUERY}`;
export const GOOGLE_MAPS_EMBED = `https://www.google.com/maps?q=${GOOGLE_MAPS_EMBED_QUERY}&output=embed`;

export const SOCIAL = {
  instagram: 'https://www.instagram.com/mahabirbastralaya?igsh=MWwxNWJ4eWZ1dWxmOA==',
  facebook: 'https://www.facebook.com/share/1KF8KETsS5/',
};

export const VISIT_HOURS = {
  days: 'Tuesday — Sunday',
  time: '10:00 AM to 8:00 PM',
  closed: 'Monday · Closed',
};

export const buildWhatsAppLink = (productName) => {
  const text = productName
    ? `Namaste Mahabir Bastralaya, I would like to enquire about "${productName}".`
    : `Namaste Mahabir Bastralaya, I would like to enquire about your traditional dress collection.`;
  return `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(text)}`;
};

export const buildWholesaleWhatsAppLink = () => {
  const text = `Namaste Mahabir Bastralaya, I would like to enquire about your WHOLESALE offerings for traditional Nepali dresses.`;
  return `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(text)}`;
};

// Resolve product image URLs: full URLs and data-URLs pass through;
// relative `/api/uploads/...` paths get the backend URL prefixed.
export const resolveImageUrl = (u) => {
  if (!u) return u;
  if (u.startsWith('http') || u.startsWith('data:')) return u;
  const base = API.replace(/\/api$/, '');
  return u.startsWith('/') ? `${base}${u}` : `${base}/${u}`;
};
